import { FC } from 'react'
import Layout from 'src/containers/Layout/Layout'
import PostList from 'src/containers/Post/PostList'
import { Category } from 'src/types'

const NewsPage: FC = () => {
  return (
    <Layout>
      <PostList queryKey="news" title="最新动态" category={Category.News} />
    </Layout>
  )
}

export default NewsPage
